import { Settings } from '@xeetr/types/models'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import Loading from '@/components/loading/Loading'
import SettingsFooter from '@/components/settings/common/SettingsFooter'
import SettingsSidebar from '@/components/settings/SettingsSidebar'
import { useSettingsTabs } from '@/hooks/settings/useSettingTabs'
import { useSettings } from '@/hooks/useSettings'
import { useTenant } from '@/hooks/useTenant'

const SettingsPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { tenant } = useTenant()
  const { settings, isLoading, save, isSaving } = useSettings()
  const items = useSettingsTabs()

  useEffect(() => {
    if (!tenant?.id) return

    const currentPath = location.pathname.replace('/settings/', '')
    const isValidRoute = items.some((item) => {
      if (item.visible === false) return false
      return item.route === currentPath
    })

    if (!isValidRoute) {
      navigate('user')
    }
  }, [tenant, items, navigate, location.pathname])

  const onSubmit = (data: Settings) => {
    save(data)
  }

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1">
        <SettingsSidebar />
        <main className="mb-20 flex min-w-0 flex-1 flex-col">
          <div className="flex-1 overflow-y-auto">
            <div className="mx-auto max-w-7xl p-6">
              <Loading loading={isLoading || !settings} label="Einstellungen werden geladen...">
                <Outlet />
              </Loading>
            </div>
          </div>
        </main>
      </div>
      <div className="bg-background fixed bottom-0 w-full shrink-0 border-t">
        <div className="mx-auto max-w-7xl">
          <SettingsFooter onSubmit={onSubmit} loading={isSaving} />
        </div>
      </div>
    </div>
  )
}

export default SettingsPage
